"use client";

import { useEffect, useState } from "react";

interface UseScrollDirectionOptions {
  threshold?: number;
}

/**
 * useScrollDirection hook - Detects scroll direction (up or down)
 * Returns true when scrolling down (should collapse), false when scrolling up (should expand)
 */
export function useScrollDirection(options: UseScrollDirectionOptions = {}): boolean {
  const { threshold = 10 } = options;
  const [isScrolledDown, setIsScrolledDown] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      const direction = scrollY > lastScrollY ? "down" : "up";

      if (
        direction !== (isScrolledDown ? "down" : "up") &&
        Math.abs(scrollY - lastScrollY) > threshold
      ) {
        setIsScrolledDown(direction === "down");
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDirection, { passive: true });

    return () => {
      window.removeEventListener("scroll", updateScrollDirection);
    };
  }, [isScrolledDown, threshold]);

  return isScrolledDown;
}
